module.exports = __webpack_public_path__ + "static/media/hot-noodles-ad8.1d83e076.png";